var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.11765 5.6665C0.948103 5.6665 0 4.7184 0 3.54886L0 2.13709C0 0.967547 0.948103 0.0194449 2.11765 0.0194449C3.28719 0.0194449 4.23529 0.967547 4.23529 2.13709L8.47059 2.13709V0.725327H9.88235V2.13709H10.5882V0.725327L12 0.725327V3.54886L4.23529 3.54886C4.23529 4.7184 3.28719 5.6665 2.11765 5.6665ZM2.82353 2.13709V3.54886C2.82353 3.9387 2.5075 4.25474 2.11765 4.25474C1.7278 4.25474 1.41176 3.9387 1.41176 3.54886L1.41176 2.13709C1.41176 1.74724 1.7278 1.43121 2.11765 1.43121C2.5075 1.43121 2.82353 1.74724 2.82353 2.13709Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ae0e480894373a82ecf066f680724788.svg";
export { ForwardRef as ReactComponent };